import requests from "./httpService";

const HrRentalPeriodicHikeDayServices = {
  getAllHrRentalPeriodicHikeDay: async (body) => {
    return requests.get(`/hrRentalPeriodicHikeDay/`);
  },

  addHrRentalPeriodicHikeDay: async (body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
    return requests.post(`/hrRentalPeriodicHikeDay/add`, formattedBody);
  },
  getHrRentalPeriodicHikeDayById: async (id) => {

    return requests.get(`/hrRentalPeriodicHikeDay/${id}`);
  },

  updateHrRentalPeriodicHikeDay: async (id, body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
  
    return requests.put(`/hrRentalPeriodicHikeDay/update/${id}`, formattedBody);
  },

  deleteHrRentalPeriodicHikeDay: async (id) => {
    return requests.delete(`/hrRentalPeriodicHikeDay/delete/${id}`);
  },
};

export default HrRentalPeriodicHikeDayServices;
